import type { Supervisor } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'
import { SHORTCUT_EMPLOYEE_FIELDS } from '@@partner:graphql/shortcuts'

export interface SupervisorInfoInput {
  id?: GQL_ID
  first_name: string
  last_name: string
  status: number
  phone: string
  email: string
  password?: string
  shopIds?: GQL_ID[]
}

export interface SaveSupervisor {
  supervisor: Supervisor
}

export interface SaveSupervisorVariables {
  supervisorInfo: SupervisorInfoInput
  upsert: boolean
}

export const GQL_MUTATION_SAVE_SUPERVISOR = gql`
  mutation($supervisorInfo: SupervisorInfoInput, $upsert: Boolean) {
    supervisor: updateSupervisor(newData: $supervisorInfo, upsert: $upsert) {
      ${SHORTCUT_EMPLOYEE_FIELDS}
      email
    }
  }
`

export const useMutateSaveSupervisor = () => {
  return useMutation<SaveSupervisor, SaveSupervisorVariables>(
    GQL_MUTATION_SAVE_SUPERVISOR
  )
}
